import React from "react";
import ReactDOM from "react-dom";
import ReactRailsUJS from "react_ujs";
import Utils from "../components/utils"
import AiAssistant from "../components/ai_assistant/ai_assistant";

window.React = React;
window.ReactDOM = ReactDOM;
window.Utils = Utils;
window.AiAssistant = AiAssistant;

var UJS = ReactRailsUJS && ReactRailsUJS.default ? ReactRailsUJS.default : ReactRailsUJS;
window.ReactRailsUJS = UJS;

function snakeToCamel(s) {
  return s.replace(/_([a-z])/g, function (_, c) { return c.toUpperCase(); })
      .replace(/^[a-z]/, function (c) { return c.toUpperCase(); });
}

const modules = import.meta.glob("../components/**/*.{jsx,tsx}", { eager: true });

// 1) Context callable para react-rails
function context(key) { return modules[key]; }
context.keys = function () { return Object.keys(modules); };
UJS.useContext(context);

// 2) Globals + aliases (por si legacy busca window.AiAssistant)
Object.keys(modules).forEach(function (path) {
  var mod = modules[path];
  var exp = mod && mod.default ? mod.default : mod;
  if (!exp) return;

  // 1) nombre “real” si existe
  var name = exp.displayName || exp.name;

  // 2) fallback por filename
  if (!name) {
    var file = path.split("/").pop();
    name = file.replace(/\.(jsx|tsx)$/, "");
  }

  window[name] = exp;
});

UJS.detectEvents();
